import { render, staticRenderFns } from "./InvoicSuccess.vue?vue&type=template&id=643184e6&scoped=true"
import script from "./InvoicSuccess.vue?vue&type=script&lang=js"
export * from "./InvoicSuccess.vue?vue&type=script&lang=js"
import style0 from "./InvoicSuccess.vue?vue&type=style&index=0&id=643184e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643184e6",
  null
  
)

export default component.exports